import React, { useEffect } from "react";
import { Separator } from "../../ui/separator"

const CreatorsAgreement = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="flex-grow bg-white py-8 md:py-12">
      <div className="container mx-auto px-2 md:px-4">
        <div className="max-w-4xl mx-auto">
          {/* Page Header */}
          <div className="mb-8 md:mb-12">
            <h1 className="text-3xl font-bold mb-6 text-center text-[#523880]">
              Creators Agreement
            </h1>
            <p className="text-sm text-gray-500 text-center mb-2">
              Part of Oye Creators Policies | TTL Media Pvt. Ltd.
            </p>
            <p className="text-sm text-gray-500 text-center mb-2">
              Effective Date: 26th May 2025
            </p>
            <p className="text-sm text-gray-500 text-center mb-8">
              Last Updated: 26th May 2025
            </p>
          </div>

          {/* Content */}
          <div className="prose prose-lg max-w-none">
            <p className="text-base leading-relaxed text-gray-800 mb-4">
              This Creators Agreement (hereinafter referred to as the
              "Agreement") is entered into by and between the individual or
              entity registering as a creator (hereinafter referred to as the
              "Creator" or "You") and TTL Media Private Limited, a company
              incorporated under the Companies Act, 2013, having its
              registered office in India and operating under the trade name
              "Oye Creators" (hereinafter referred to as the "Company", "Oye
              Creators", "We", "Us", or "Our").
            </p>

            <p className="text-base leading-relaxed text-gray-800 mb-4">
              By registering and participating on the Oye Creators platform,
              You agree to be legally bound by this Agreement, including all
              terms herein, and any supplementary policies such as the Privacy
              Policy, Terms of Use, and related operational documents.
            </p>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mt-8 mb-4 text-[#EE3788]">
                1. Eligibility
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                1.1. The Creator must be at least sixteen (16) years of age to
                be eligible to register and participate in campaigns through
                the Oye Creators platform.
              </p>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                1.2. Creators under the age of eighteen (18) shall be required
                to obtain explicit written consent from a parent or legal
                guardian, who shall co-sign or submit an undertaking on behalf
                of the minor Creator.
              </p>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                1.3. The Creator affirms and warrants that all information
                provided at the time of registration and thereafter is
                truthful, accurate, and complete to the best of their
                knowledge.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#EE3788]">
                2. Engagement and Deliverables
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                2.1. Upon being selected for a campaign or project ("Gig"),
                the Creator undertakes to deliver the required content in
                accordance with the brief provided by Oye Creators or its
                clients.
              </p>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                2.2. The Creator shall strictly adhere to deadlines, content
                specifications, posting instructions, and any other
                deliverables communicated in writing.
              </p>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                2.3. Failure to deliver within specified parameters shall
                entitle Oye Creators to cancel the engagement without
                compensation and may affect future selection for campaigns.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#EE3788]">
                3. Content Guidelines
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                3.1. The Creator shall ensure that all submitted content is
                original and does not infringe upon any third-party
                intellectual property or rights.
              </p>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                3.2. The Creator shall not produce or distribute content that
                is:
              </p>
              <ul className="list-disc ml-6 space-y-1 mb-4">
                <li className="text-base leading-relaxed text-gray-800">
                  Defamatory, obscene, violent, or pornographic
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Promoting hate speech, communal disharmony, or abusive
                  conduct
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Religious, caste-based, or anti-mankind in nature
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Misleading, fake, or in violation of advertising standards
                  or community guidelines of social platforms
                </li>
              </ul>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                3.3. All content must comply with the applicable laws of India
                and the terms of service of relevant digital platforms.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#EE3788]">
                4. Intellectual Property Rights
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                4.1. The Creator retains ownership of their content unless
                explicitly transferred by separate agreement.
              </p>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                4.2. Where the Creator has been compensated for a Gig, Oye
                Creators shall have perpetual, irrevocable, worldwide rights
                to use, modify, distribute, license, sublicense, and authorize
                the use of such content in any digital format, including but
                not limited to:
              </p>
              <ul className="list-disc ml-6 space-y-1 mb-4">
                <li className="text-base leading-relaxed text-gray-800">
                  Social Media Platforms
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Google, Meta, or YouTube Advertisements
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Digital banners, promotional videos, email marketing, reels,
                  or campaign archives
                </li>
              </ul>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                4.3. Exclusive rights and additional compensation shall only
                apply if explicitly agreed in writing.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#EE3788]">
                5. Rights to Use Shared Information
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                5.1. The Creator agrees that Oye Creators and its authorized
                associates, affiliates, clients, and legal representatives may
                store, process, and utilize all profile-related data,
                statistics, content, communication, or personal branding
                assets submitted during onboarding or campaign execution.
              </p>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                5.2. This includes bio, handles, follower metrics, engagement
                rates, content formats, analytics, and other metadata, which
                may be used for performance tracking, brand matchmaking, and
                promotional purposes.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#EE3788]">
                6. Payments & Statutory Deductions
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                6.1. Creators shall be paid within thirty (30) working days
                following successful completion, brand approval, and campaign
                closure.
              </p>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                6.2. The Creator acknowledges and agrees to statutory tax
                deductions:
              </p>
              <ul className="list-disc ml-6 space-y-1 mb-4">
                <li className="text-base leading-relaxed text-gray-800">
                  TDS at 10% under Section 194J or other applicable provisions
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  TCS at 1%, if applicable
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  TDS at 20%, in cases of inactive or invalid PAN
                </li>
              </ul>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                6.3. Creators may opt out of TDS if submitting a valid
                declaration stating self-responsibility for tax filings under
                prevailing Indian tax laws.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#EE3788]">
                7. Non-Compete Clause
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                7.1. During the tenure of any campaign and for a period of
                thirty (30) days following the completion of the campaign, the
                Creator shall not participate in a directly competing campaign
                (i.e., for a brand operating in the same product category)
                without the express written consent of Oye Creators.
              </p>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                7.2. The Creator further agrees not to misuse proprietary
                briefs, pricing, communication formats, or campaign ideas
                received through Oye Creators in any form with competing
                agencies or platforms.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#EE3788]">
                8. Confidentiality
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                8.1. The Creator agrees to maintain the confidentiality of all
                campaign briefs, client identities (if not disclosed
                publicly), strategies, and pricing information.
              </p>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                8.2. Unauthorized disclosure may result in legal proceedings
                and disqualification from future campaigns.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#EE3788]">
                9. Indemnification
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                9.1. The Creator hereby agrees to indemnify, defend, and hold
                harmless Oye Creators, TTL Media Pvt. Ltd., its directors,
                officers, employees, agents, clients, and representatives from
                any and all claims, liabilities, losses, damages, penalties,
                costs, and expenses (including reasonable attorney fees)
                arising from:
              </p>
              <ul className="list-disc ml-6 space-y-1 mb-4">
                <li className="text-base leading-relaxed text-gray-800">
                  Breach of this Agreement
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Violation of applicable law or third-party rights
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Infringement of intellectual property
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Misrepresentation of credentials, statistics, or
                  deliverables
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Unauthorized use of third-party music, visuals, or
                  copyrighted content
                </li>
              </ul>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                9.2. This indemnity obligation shall survive the expiration or
                termination of this Agreement.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#EE3788]">
                10. Termination
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                10.1. Either Party may terminate this Agreement at any time by
                giving written notice.
              </p>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                10.2. Oye Creators reserves the right to terminate with
                immediate effect if the Creator breaches any material term
                herein.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#EE3788]">
                11. Governing Law and Jurisdiction
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                11.1. This Agreement shall be governed by and construed in
                accordance with the laws of India.
              </p>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                11.2. Any disputes shall be subject to the exclusive
                jurisdiction of the competent courts located in Pune,
                Maharashtra.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#EE3788]">
                12. Entire Agreement
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                12.1. This document represents the full and complete
                understanding between the Parties and supersedes all prior
                communications.
              </p>
              <p className="text-base leading-relaxed text-gray-800 mb-2">
                12.2. No amendment shall be valid unless made in writing and
                signed by both Parties.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <p className="text-base leading-relaxed text-gray-800 font-medium">
                By signing up on the Oye Creators platform using a registered
                mobile number, the Creator explicitly confirms that they have
                read, understood, and accepted the terms of this Agreement.
                This digital acknowledgment is considered a valid and binding
                acceptance of this Agreement and forms an integral part of the
                Creator's onboarding process. No physical or manual signature
                shall be required.
              </p>
            </section>
          </div>
        </div>
      </div>
    </main>
  )
}

export default CreatorsAgreement
